<label
	*ngIf="label !== null"
	class="form-label"
	[class.required]="isRequired"
	[class.invalid]="isInvalid"
	[class.d-block]="headerLabelDisplayBlock"
	>{{ label }}</label
>
<div
	ngbDropdown
	class="flex-fill pseudo-form-control"
	#ngbDropdown="ngbDropdown"
	[class.disabled]="disabled"
	[autoClose]="insideClick"
	(openChange)="openChanged($event)"
	(keydown)="textTyped($event)">
	<a ngbDropdownToggle [ngClass]="dropdownToggleClasses" href="javascript:void(0)" role="button" aria-haspopup="true" aria-expanded="false">
		<span class="dropdown-toggle-text-container" [attr.alt]="dropdownToggleText">
			<ng-container [ngTemplateOutlet]="nameTemplate" [ngTemplateOutletContext]="{ $implicit: option }"></ng-container>
			<span *ngIf="dropdownToggleText" [innerHTML]="dropdownToggleText"></span>
			<ng-container
				*ngIf="!nameTemplate && option !== null && !templateOnlyMenu && !dropdownToggleText"
				[ngTemplateOutlet]="rowRef"
				[ngTemplateOutletContext]="{ $implicit: option }">
			</ng-container>
		</span>
	</a>
	<div ngbDropdownMenu class="scroll-dropdown" [ngClass]="dropdownMenuClasses">
		<div #scrollingArea class="row scrolling-area" [ngClass]="dropdownMenuRowClasses">
			<div class="col container-column">
				<a
					*ngIf="nullOptionSelectable && nullOption"
					(click)="onSelect(null, $event)"
					[class.selected-item]="option === null"
					href="javascript:void(0)"
					class="dropdown-item">
					{{ nullOption }}
				</a>
				<a
					*ngFor="let rowOption of visibleOptions"
					(click)="onSelect(rowOption, $event)"
					class="dropdown-item"
					#optionsRef
					[class.selected-item]="rowOption === option"
					href="javascript:void(0)">
					<span *ngIf="!rowRef" [innerHTML]="boldMap(textMap(rowOption))"></span>
					<ng-container [ngTemplateOutlet]="rowRef" [ngTemplateOutletContext]="{ $implicit: rowOption }"></ng-container>
				</a>
			</div>
		</div>
	</div>
</div>
